module.exports = __webpack_public_path__ + "img/image2.34568e1c.png";